<template>
    <v-container v-if="!selectedAd">
        <v-card>
            <v-flex v-if="currentCardAds">
                <v-row v-for="(ad, index) in currentCardAds" style="justify-content: space-between;" :key="ad.localId">
                    <v-col class="start ml-6"><img class="ma-5" v-if="ad.isActive" :src="activationIcon" height="40px" width="40px" />{{ ad.localId }}</v-col>
                    <v-col md="3" sm="4" cols="5">
                        <v-row>
                            <site-button
                                :colNum="5"
                                @click-event="editAd(index)"
                                :iconString="editIcon"
                                :toolTip="'Edit Ad'"
                                iconType="SVG"
                                btnType="text"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon list-btn"
                            ></site-button>
                            <site-button
                                :colNum="5"
                                @click-event="deleteAd(index)"
                                :toolTip="'Delete Ad'"
                                iconColor="secondary-icon list-btn"
                                colorClasses="secondary-icon"
                                iconType="ICON"
                                iconString="fas fa-trash"
                            ></site-button>
                        </v-row>
                    </v-col>
                </v-row>
            </v-flex>
            <v-row class="center">
                <site-button
                    colorClasses="secondary-icon ma-8"
                    @click-event="createNewAd"
                    :colNum="11"
                    toolTip="New Advertisement"
                    iconType="ICON"
                    iconString="fas fa-plus-square"
                ></site-button>
            </v-row>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-row>
            <v-col cols="2">
                <site-button
                    @click-event="unselectAd"
                    btnType="tile"
                    colorClasses="calendar-add-btn"
                    toolTip="Back To Ad Selection"
                    iconType="ICON"
                    iconString="fas fa-arrow-left"
                ></site-button>
            </v-col>
            <v-col cols="8"></v-col>
            <v-col cols="2">
                <site-button
                    v-if="hasChanged"
                    @click-event="saveCard"
                    btnType="tile"
                    colorClasses="calendar-add-btn"
                    toolTip="Save Changes"
                    iconType="ICON"
                    iconString="far fa-save"
                ></site-button>
            </v-col>
        </v-row>
        <v-row class="center">
            <v-col cols="11" sm="8" md="6" xl="5">
                <mock-dating-card
                    :isActive="selectedAd.isActive"
                    :updateIndex="updateAdIndex"
                    @activate="activateAd"
                    @target-market="navToTargetMarket"
                    :interestedClick="openActionDialogClick"
                    :imageSrc="displayImage"
                    :imageClick="openFileDialogClick"
                    :title="selectedAd.label"
                ></mock-dating-card>
            </v-col>
        </v-row>
        <branding-file-dialog
            :showDialog="showFileDialog"
            @uploaded="uploadedFile"
            @send-email="sendEmail"
            @set-dialog-control="setFileDialogControl"
        ></branding-file-dialog>
        <branding-interested-dialog
            :showDialog="showActionDialog"
            :action="selectedAd ? selectedAd.linkType : 'None'"
            :input="selectedAd ? selectedAd.link : ''"
            @submit-interests="setInterests"
            @set-dialog-control="setActionDialogControl"
        ></branding-interested-dialog>
    </v-container>
</template>

<style lang="scss" scoped>
@import '../../../styles/styles.scss';
</style>

<script>
import MockDatingCard from '../../../components/common/MockDatingCard'
import BrandingFileDialog from '../../../components/common/BrandingFileDialog'
import BrandingInterestedDialog from '../../../components/common/BrandingInterestedDialog'
import SiteButton from '../../../components/common/SiteButton'
import AdvertisementType from '../../../assets/Enums/AdvertisementType'
import TrafficType from '../../../assets/Enums/TrafficType'
import { nanoid } from 'nanoid';

const today = new Date()

export default {
    name: 'business-branding',
    components: {
        'mock-dating-card': MockDatingCard,
        'branding-file-dialog': BrandingFileDialog,
        'branding-interested-dialog': BrandingInterestedDialog,
        'site-button': SiteButton,
    },
    props: {
        passedAd: {
            type: Object,
            default: null,
        }
    },
    data: () => ({
        isNew: false,
        showFileDialog: false,
        showActionDialog: false,
        fileUrl: '',
        selectedAd: null,
        hasChanged: false,
    }),
    created() {
        this.selectedAd = this.passedAd || null;
        if(this.selectedAd && !this.selectedAd.localId){
            this.selectedAd.localId = nanoid(6);
        }
    },
    methods: {
        createNewAd() {
            this.selectedAd = {
                localId: nanoid(6),
                isActive: false,
                partnerId: this.$store.getters.partnerId,
                label: '',
                labelColor: '',
                link: '',
                linkType: '',
                position: '',
                src: '',
                type: AdvertisementType.CARD,
                targetMarket: {
                    ageStart: 21,
                    ageEnd: 70,
                    genders: [],
                    activeAreas: [],
                    keyWords: [],
                },
                traffic: {
                    entries: [
                        {
                            term: today.toISOString().substring(0, 7),
                            day: today.getDate(),
                            traffic: 0,
                            trafficType: TrafficType.CardAd,
                        },
                    ],
                    trafficType: TrafficType.CardAd,
                },
            }
            this.hasChanged = true;
            this.isNew = true;
        },
        editAd(adIndex){
            console.log('ed' + adIndex);
            this.selectedAd = this.currentCardAds[adIndex];
            this.fileUrl = this.currentCardAds[adIndex].srcString;
        },
        deleteAd(adId){
            const deleteId = this.localAds.findIndex(s => s.localId === adId);

            this.$store.dispatch('DELETE_AD_DESIGN', deleteId);
        },
        unselectAd(){
            this.selectedAd = null;
            this.isNew = false;
        },
        openFileDialogClick() {
            this.showFileDialog = true
        },
        setFileDialogControl(val) {
            this.showFileDialog = val
        },
        openActionDialogClick() {
            this.showActionDialog = true
        },
        setActionDialogControl(val) {
            this.showActionDialog = val
        },
        setInterests(interest) {
            this.selectedAd.linkType = interest.chosenAction
            this.selectedAd.link = interest.actionInput
            this.hasChanged = true
        },
        uploadedFile(cardAd) {
            this.selectedAd.label = cardAd.label;
            this.selectedAd.src = cardAd.srcString;

            this.fileUrl = cardAd.srcString;
            this.hasChanged = true
        },
        sendEmail(emailInfo) {
            this.sendBrandingRequest(emailInfo.desc, emailInfo.dueDate);
        },
        activateAd(updateIndex){
            const localId = this.selectedAd.localId;
            const activeIndex = this.$store.state.tempAdvertisements.findIndex(s => s && s.localId === localId);
            if(activeIndex < 0) return;

            this.$store.dispatch('ACTIVATE_AD', updateIndex);
            this.$store.dispatch('UPDATE_ADVERTISEMENTS').then(() => {
                console.log('updated!');
                this.$router.push({ name: 'business-target-markets', params: { adIndex: activeIndex } });
            });
        },
        navToTargetMarket(index){
            this.$router.push({ name: 'business-target-markets', params: { adIndex: index } });
        },
        async saveCard() {
            if (this.isNew) {
                const adIndex = await this.$store.dispatch('SUBMIT_AD_DESIGN', { ad: this.selectedAd, index: this.updateAdIndex });
                if(this.selectedAd.isActive){
                    this.$router.push({ name: 'business-target-markets', params: { adIndex: adIndex } });
                }
            } else {
                this.$store.dispatch('UPDATE_AD_DESIGN', { ad: this.selectedAd, index: this.updateAdIndex });
                if(!this.selectedAd.isActive){
                    this.$router.push({ name: 'business-target-markets', params: { adIndex: this.updateAdIndex } });
                }
            }
        },
    },
    computed: {
        displayImage() {
            return this.selectedAd ? this.selectedAd.src || this.selectedAd.srcString : this.fileUrl;
        },
        currentCardAds() {
            return this.$store.getters.cardAds;
        },
        localAds(){
            return this.$store.state.tempAdvertisements;
        },
        allAds(){
            return this.$store.getters.allAds;
        },
        updateAdIndex(){
            return this.$store.state.tempAdvertisements.findIndex(s => s && s.localId === this.selectedAd.localId);
        },
        editIcon(){
            return require('../../../assets/Edit-Icon.svg');
        },
        activationIcon() {
            return require('../../../assets/Activate-Icon.svg');
        },
    },
}
</script>
